import Pusher from 'pusher-js'
import { createContext, useContext } from 'react'

export const PusherContext = createContext<Pusher | null>(null)

export const usePusherInstance = () => useContext(PusherContext)
